<template>
  <span
    class="animate__animated animate__fadeInDown animate__infinite pull-down-arrow-box"
  >
    <i class="el-icon-bottom" />
  </span>
</template>

<script>
export default {
  name: 'PullDownNoticeArrow',
};
</script>

<style scoped>
  .pull-down-arrow-box{
    width: 29px;
    height: 29px;
    animation-duration: 2s;
    position: absolute;
    bottom: 50px;
    font-size:28px;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 3px;
    display: flex;
    text-align: center;
  }
</style>
